import React, { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import DefaultContext from "../../contexts/DefaultContext";
import styled from "@emotion/styled";
import Select from "react-dropdown-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faCheck } from "@fortawesome/free-solid-svg-icons";

function SignUp() {
  let [organisations, setOrganisations] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  const history = useHistory("");
  const { register, handleSubmit, watch } = useForm("");
  const { addFlashMessage, setAlert } = useContext(DefaultContext);
  const token = sessionStorage.getItem("complexToken");
  let [createNewOrg, setCreateNewOrg] = useState(false);
  let [newOrgName, setNewOrgName] = useState("");

  const passwordValue = watch("password", "");

  const StyledSelect = styled(Select)`
    ${({ dropdownRenderer }) =>
      dropdownRenderer &&
      `
      .react-dropdown-select-dropdown {
        overflow: initial;
      }
    `}
  `;

  const criteria = [
    { label: "Min. 8 tekens", ok: passwordValue.length >= 8 },
    { label: "1 hoofdletter (A-Z)", ok: /[A-Z]/.test(passwordValue) },
    { label: "1 kleine letter (a-z)", ok: /[a-z]/.test(passwordValue) },
    { label: "1 cijfer (0-9)", ok: /[0-9]/.test(passwordValue) },
    { label: "1 speciaal teken (#?!@$%^&*_-)", ok: /[#?!@$%^&*_-]/.test(passwordValue) },
  ];

  const onSubmit = (data) => {
    data.userName = data.email;
    data.organisationId = createNewOrg ? 0 : selected[0].value;

    if (-1 == data.password.search("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*_-]).{8,}$")) {
      addFlashMessage("Uw wachtwoord moet minstens 8 tekens bevatten met minstens 1 hoofdletter, 1 kleine letter, 1 nummer en 1 speciaal teken", "warning");
      setAlert(true);
      return;
    }

    axios.get("Users/CheckEmail/" + data.email)
      .then((response) => {
        if (response.data) {
          addFlashMessage("Dit emailadres is al in gebruik.", "danger");
          setAlert(true);
        } else {
          if (createNewOrg === "false" && (data.organisationId === 0 || data.organisationId === "0")) {
            addFlashMessage("U heeft geen organisatie aangeduid.", "danger");
            setAlert(true);
          } else {
            if (createNewOrg) {
              if (!newOrgName.trim()) {
                addFlashMessage("Voer een naam in voor uw organisatie.", "warning");
                setAlert(true);
                return;
              }
              let orgData = { organisationName: newOrgName, contactEmail: data.email };
              axios.post("/Organisations/Register", orgData)
              .then((res) => {
                data.organisationId = res.data.id;
                postUser(data);
              })
              .catch((err) => {
                addFlashMessage("Er is iets fout gelopen bij het aanmaken van de organisatie. Probeer later opnieuw.", "danger");
                setAlert(true);
                console.log(err);
              });
            } else {
              postUser(data);
            }
          }
        }
      }).catch((error) => {
        addFlashMessage("Er is iets fout gelopen met de server. Probeer later opnieuw.", "danger");
        setAlert(true);
        console.log(error);
      });
  };

  function postUser(data) {
    axios.post("/Users/", data)
    .then(() => {
      addFlashMessage("Uw profiel is aangemaakt. Na goedkeuring kan je inloggen.", "success");
      setAlert(true);
      goToHome();
    })
    .catch(() => {
      addFlashMessage("Er is iets fout gelopen met de server. Probeer later opnieuw.", "danger");
      setAlert(true);
    });
  }

  useEffect(() => {
    getOrganisationData();
  }, []);

  function goToHome() {
    history.push("/");
  }

  const getOrganisationData = () => {
    organisations = [];
    axios
      .get(`/Organisations/`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        res.data.map((res) =>
          res.id !== 1 &&
          organisations.push({ label: `${res.organisationName}`, value: res.id })
        );
        setOrganisations(organisations);
      })
      .catch((err) => console.log(err));
  };

  function selectExistingOrg() {
    setNewOrgName("");
    setCreateNewOrg(false);
  }

  function selectNewOrg() {
    setCreateNewOrg(true);
  }

  const fieldStyle = {
    width: "100%",
    padding: "0.55rem 0.75rem",
    borderRadius: "6px",
    border: "1px solid rgba(255,255,255,0.3)",
    backgroundColor: "rgba(255,255,255,0.95)",
    fontSize: "1rem",
    color: "#333",
    boxSizing: "border-box",
  };

  const labelStyle = {
    color: "white",
    fontWeight: "600",
    marginBottom: "0.3rem",
    display: "block",
    fontSize: "0.9rem",
    letterSpacing: "0.02em",
  };

  const sectionStyle = { marginBottom: "1.1rem" };

  const toggleBtnStyle = (active) => ({
    flex: 1,
    padding: "0.45rem 0.75rem",
    borderRadius: "6px",
    border: "2px solid rgba(255,255,255,0.7)",
    backgroundColor: active ? "white" : "transparent",
    color: active ? "#2d5971" : "white",
    fontWeight: active ? "700" : "400",
    cursor: "pointer",
    fontSize: "0.85rem",
    transition: "all 0.15s",
  });

  return (
    <div className="">
      <div className="outer">
        <div className="inner" style={{ maxWidth: "420px", width: "100%" }}>
          <form onSubmit={handleSubmit(onSubmit)} style={{ padding: "0 0.5rem" }}>

            <div style={{ marginBottom: "1.5rem" }}>
              <p style={{ color: "white", fontSize: "1.5rem", fontWeight: "700", margin: 0 }}>
                Registreer
              </p>
              <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.9rem", margin: "0.25rem 0 0" }}>
                Al een account?{" "}
                <Link to="/sign-in" style={{ color: "white", fontWeight: "600" }}>Log in</Link>
              </p>
            </div>

            {/* Naam */}
            <div style={{ display: "flex", gap: "0.75rem", marginBottom: "1.1rem" }}>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Voornaam</label>
                <input
                  type="text"
                  style={fieldStyle}
                  placeholder="Voornaam"
                  required
                  pattern="[a-zA-Z -]{1,20}"
                  title="Enkel letters zijn toegelaten"
                  autoComplete="given-name"
                  {...register("firstName")}
                />
              </div>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Familienaam</label>
                <input
                  type="text"
                  style={fieldStyle}
                  placeholder="Familienaam"
                  required
                  pattern="[a-zA-Z -]{1,20}"
                  title="Enkel letters zijn toegelaten"
                  autoComplete="family-name"
                  {...register("lastName")}
                />
              </div>
            </div>

            {/* E-mail */}
            <div style={sectionStyle}>
              <label style={labelStyle}>E-mailadres</label>
              <input
                type="email"
                style={fieldStyle}
                placeholder="naam@organisatie.be"
                required
                autoComplete="email"
                {...register("email")}
              />
            </div>

            {/* Wachtwoord */}
            <div style={sectionStyle}>
              <label style={labelStyle}>Wachtwoord</label>
              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  style={{ ...fieldStyle, paddingRight: "2.8rem" }}
                  placeholder="Wachtwoord"
                  required
                  autoComplete="new-password"
                  {...register("password")}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "0.75rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#888",
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                  }}
                  tabIndex={-1}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>

              {/* Live criteria */}
              {passwordValue.length > 0 && (
                <div style={{ marginTop: "0.5rem", display: "flex", flexDirection: "column", gap: "0.18rem" }}>
                  {criteria.map(({ label, ok }) => (
                    <div key={label} style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                      {ok ? (
                        <FontAwesomeIcon
                          icon={faCheck}
                          style={{ color: "#4ade80", fontSize: "0.65rem", width: "0.7rem", flexShrink: 0 }}
                        />
                      ) : (
                        <span style={{
                          display: "inline-block",
                          width: "0.45rem",
                          height: "0.45rem",
                          borderRadius: "50%",
                          backgroundColor: "rgba(255,255,255,0.3)",
                          flexShrink: 0,
                          marginLeft: "0.125rem",
                        }} />
                      )}
                      <span style={{
                        color: ok ? "rgba(255,255,255,0.95)" : "rgba(255,255,255,0.45)",
                        fontSize: "0.78rem",
                      }}>
                        {label}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Functie */}
            <div style={sectionStyle}>
              <label style={labelStyle}>Functie</label>
              <select style={fieldStyle} required {...register("grade")}>
                <option value="">Kies een functie...</option>
                <option value="Employer">Verantwoordelijke — maakt trajecten aan en volgt op</option>
                <option value="Admin">Beheerder — beheert de organisatie</option>
              </select>
            </div>

            {/* Organisatie */}
            <div style={sectionStyle}>
              <label style={labelStyle}>Organisatie</label>
              <div style={{ display: "flex", gap: "0.5rem", marginBottom: "0.6rem" }}>
                <button type="button" onClick={selectExistingOrg} style={toggleBtnStyle(!createNewOrg)}>
                  Bestaande organisatie
                </button>
                <button type="button" onClick={selectNewOrg} style={toggleBtnStyle(createNewOrg)}>
                  Nieuwe organisatie
                </button>
              </div>
              {createNewOrg ? (
                <input
                  type="text"
                  style={fieldStyle}
                  placeholder="Naam van de nieuwe organisatie"
                  pattern="[a-zA-Z -]{1,64}"
                  title="Enkel letters zijn toegelaten"
                  autoComplete="off"
                  onChange={(e) => setNewOrgName(e.target.value)}
                />
              ) : (
                <StyledSelect
                  style={{ backgroundColor: "white", borderRadius: "6px" }}
                  options={organisations}
                  values={selected}
                  onChange={setSelected}
                  labelledBy="Selecteer"
                  placeholder="Selecteer uw organisatie"
                />
              )}
            </div>

            <button
              type="submit"
              style={{
                width: "100%",
                marginTop: "0.5rem",
                padding: "0.75rem",
                backgroundColor: "white",
                color: "#2d5971",
                border: "none",
                borderRadius: "6px",
                fontSize: "1rem",
                fontWeight: "700",
                cursor: "pointer",
                letterSpacing: "0.03em",
              }}
            >
              Account aanmaken
            </button>

          </form>
        </div>
      </div>
    </div>
  );
}

export default SignUp;
